/**
 * GenovaAdmin.tsx — Admin → Integrations → Genova Diagnostics.
 * Thin wrapper over the reusable LabIntegrationAdmin.
 */
import { LabIntegrationAdmin } from '@/pages/admin/LabIntegrationAdmin';

export function GenovaAdmin() {
  return (
    <LabIntegrationAdmin
      integrationKey="genova"
      title="Genova Diagnostics"
      subtitle="Systems-based clinical lab tests (GI, hormone, nutritional, allergy) via the Genova Diagnostics API"
      vendorName="Genova"
    />
  );
}
